import { supportsPDFs } from 'pdfobject'

export const pdfSupported = supportsPDFs
